module.exports = __webpack_public_path__ + "media/images/front/icons/arrow-right-lightgray-91ab0b86a28b7d1fc0b451201bfc7c72.svg";